export class FamilyPlanConfig {
  public static pinLength = 4;
  public static determineMaxMembersForFamilyPlan() {
    // TODO: configure to non hard coded value when ready
    return 5;
  }
}
